var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFaq = function SvgFaq(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    clipPath: "url(#faq_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 1.25a8.75 8.75 0 1 0 0 17.5 8.75 8.75 0 0 0 0-17.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.883 14.342a1.701 1.701 0 1 0 3.402 0 1.701 1.701 0 0 0-3.402 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.83 4.375c-1.93 0-3.567 1.147-3.888 2.43-.295 1.177.41 2.19 1.57 2.126.26-.014.5-.126.722-.259a30 30 0 0 1 1.597-.894c-.989.547-2.756 1.36-2.756 2.56l-.002 1.257a1.04 1.04 0 0 0 1.042 1.044h.883a1.04 1.04 0 0 0 1.042-1.042v-.173c1.79-.96 3.193-1.779 3.193-3.646 0-1.702-1.026-3.403-3.402-3.403"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "faq_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgFaq;